import SwaggerUI from 'swagger-ui'
window.SwaggerUI = SwaggerUI;
